import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sb-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
    companyCheck = localStorage.getItem('company');
    @Input() dark = false;
    constructor() {}
    ngOnInit() {}
}
